const btZipcode = getCookie('bt-cx-zipcode');
// const btPriceZone = getCookie('bt-cx-price_zone');    
const maxZipLength = 5;

document.addEventListener("DOMContentLoaded", function() {
    // console.log([btZipcode, btPriceZone]);
    // if (btZipcode && btPriceZone) {
    if (btZipcode) { 
        populateZipElements(btZipcode);
        // showOnlyPriceZoneProducts();      
        // setTimeout( () => {
        //     showOnlyPriceZoneRecommendedProducts();
        // }, 800)   
    }
    else {
      const pageTitle = document.querySelector('h1.section-header__title');
      const shouldToggleZip = (pageTitle && (pageTitle.innerHTML === 'Not Authorized' || pageTitle.innerHTML === 'Transfer Not Successful')) ? false : true;
      if (shouldToggleZip) {
        toggleZipcodeModal();
      }
    }

    let zipField = document.querySelector('#zipcode-field');
    zipField.addEventListener('keydown', function() {
        if (this.value.length >= maxZipLength) {
            this.value = this.value.substr(0, maxZipLength)
        }
    });
    zipField.addEventListener('keyup', function() {
        if (this.value.length >= maxZipLength) {
            this.value = this.value.substr(0, maxZipLength)
        }
    });

    let zipInputs = document.querySelectorAll('.zip-input, .zip-icon-wrapper, .zip-input-text');
    zipInputs.forEach(function(elem) {
        elem.addEventListener("click", function() {
            let navDrawer = document.querySelector('#NavDrawer');
            if (navDrawer.classList.contains('drawer--is-open')) {
                document.querySelector('#NavDrawer .drawer__close-button').click();
            }
            toggleZipcodeModal();
        });
    });

    let zipcodeForm = document.querySelector('#zipcode-form');
    zipcodeForm.addEventListener('submit', function(e) {
        e.preventDefault();    
        const zipcodeValue = document.querySelector('#zipcode-field').value;
        if (zipcodeValue.length !== maxZipLength) {
            document.querySelector('#zipcode-form .modal-error').innerHTML = "Please enter a 5 digit zipcode";
            return false;
        }
        callZipApi(zipcodeValue);
    });
    let zipcodeFormAlt = document.querySelector('#zipcode-form-alt');
    if (zipcodeFormAlt) {
        zipcodeFormAlt.addEventListener('submit', function(e) {
            e.preventDefault();    
            const zipcodeValue = document.querySelector('input[name="zipcode-alt"]').value;
            if (zipcodeValue.length !== maxZipLength) {
                document.querySelector('#zipcode-form-alt .modal-error').innerHTML = "Please enter a 5 digit zipcode";
                return false;
            }
            callZipApi(zipcodeValue, '#zipcode-form-alt');
        });
    }
});

function populateZipElements(zipcode) {
    let zipInput = document.querySelectorAll('.zip-input');    
    let zipInputAlt = document.querySelector('input[name="zipcode-alt"]');    
    let zipField = document.querySelector('#zipcode-field');
    let zipTexts = document.querySelectorAll('.zip-input-text');

    for (let i = 0; i < zipInput.length; i++) {
        zipInput[i].value = zipcode;
    }
    zipField.value = zipcode;

    for (let zipText of zipTexts) {
      if (zipText) {
          zipText.innerHTML = zipcode;
      }
    }
    if (zipInputAlt) {
        zipInputAlt.value = zipcode;
    }
    

}

function toggleZipcodeModal(show = true) {
    if (show) {
        document.querySelector('#zipcode-modal').style = 'display: block';
        document.querySelector('#zipcode-field').focus();
    }
    else {
        document.querySelector('#zipcode-modal').style = 'display: none';
    }
}
function hasManuallyExcludedZipcode(zipCode) {
    const zipCodeExMin = 32004;
    const zipCodeExMax = 34997;
    const zipCodeInt = parseInt(zipCode);
    if (zipCodeInt >= zipCodeExMin && zipCodeInt <= zipCodeExMax) {
        return true;
    }
    return false;
}
function callZipApi(zipCode, formEl = '#zipcode-form') {
    console.log('callZipApi with zipcode', zipCode);
    if (hasManuallyExcludedZipcode(zipCode)) {
        document.querySelector(formEl+' .modal-error').innerHTML = 'Installation not available in your area.';
        return false;
    }
    zipcodeLoading(false);
    const apiUrl = 'https://dev.bypboh.com/api/zipcode';
    const data = JSON.stringify({
        postal_code: zipCode,
        brand: 'Big Timber'
    });
    console.log(1);
    fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: data
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        const zipAccepted = data.status;
        if (zipAccepted) {
            console.log("data==>",data);
            let distributionCode = data.distribution_center_number;
            if(data.distribution_center_number){
                _updateCartNote(distributionCode);
            }
            console.log("distributionCode==>",distributionCode);
            showZipChecked();
            setCookie("bt-cx-zipcode", `${data.searched_postal_code}`, 365);
            // setCookie("bt-cx-price_zone", `${data.price_zone}`, 365);
            populateZipElements(data.searched_postal_code);
            // showOnlyPriceZoneProducts();
            // clearItemsInCart();
        }
        else {
            document.querySelector(formEl+' .modal-error').innerHTML = data.message;
        }
        setTimeout(function() {
            zipcodeLoading(true, zipAccepted);
        }, 1000);
    })
    .catch((error) => {
        // console.log(6);
        document.querySelector(formEl+' .modal-error').innerHTML = "Installation not available in your area.";
        zipcodeLoading(true);
    });
}

function _updateCartNote(branchCode) {
    const cartNote = `Branch #: ${branchCode}`;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: cartNote })
    })
        .then(response => response.json())
        .then(data => {
          // Optionally refresh cart UI or notify user here
        })
        .catch(error => {
          console.error('Error updating cart note:', error);
        });
  }

function showZipChecked() {
    let zipCheck = document.querySelector('.zip-accepted-check');
    zipCheck.classList.add('check-active');
    setTimeout(function() {
        zipCheck.classList.remove('check-active');
    }, 2000);
}
function showOnlyPriceZoneRecommendedProducts() {
    let priceZone = getCookie('bt-cx-price_zone');
    let gridProducts = document.querySelectorAll('.product-recommendations .grid-product');
    gridProducts.forEach(function(el) {
        let productTier = el.dataset.tier;
        if (parseInt(productTier) !== parseInt(priceZone)) {
            el.remove();
        }
    });
}
// function showOnlyPriceZoneProducts() {
//     let priceZone = getCookie('bt-cx-price_zone');
//     let gridProducts = document.querySelectorAll('.grid-product');
//     gridProducts.forEach(function(el) {
//         let productTier = el.dataset.tier;
//         if (parseInt(productTier) !== parseInt(priceZone)) {
//             el.remove();
//         }
//     });

//     let productFormWrapper = document.querySelector('.product-form-wrapper');
//     if (productFormWrapper) {
//         let dataTier = productFormWrapper.dataset.tier;
//         if (parseInt(dataTier) !== parseInt(priceZone)) {
//             productFormWrapper.innerHTML = '<p style="color:red">Product unavailable for your zipcode.</p>';
//         }
//     }
// }
function clearItemsInCart() {
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST'
    })
    .then(response => {
        return response.json();
    })
    .then(data => {
        $('body').trigger('zipcode.changed', data);
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}
function zipcodeLoading(complete, closeModal = false) {    
    if (complete) {
        document.querySelector('.zipcode-submit-btn').classList.remove('button--loading');
        if (closeModal) {
          toggleZipcodeModal(false);
        }            
    }
    else {
        $('.modal-error').html('');
        document.querySelector('.zipcode-submit-btn').classList.add('button--loading');    
    }
}

function setCookie(name, value, daysToLive) {
    // Encode value in order to escape semicolons, commas, and whitespace
    var cookie = name + "=" + encodeURIComponent(value);
    
    if(typeof daysToLive === "number") {
        /* Sets the max-age attribute so that the cookie expires
        after the specified number of days */
        cookie += "; path=/; secure; max-age=" + (daysToLive*24*60*60);
        
        document.cookie = cookie;
    }
}
function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");
    
    // Loop through the array elements
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        
        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if(name == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }
    
    // Return null if not found
    return null;
}